import React, { useState } from 'react';
import { Spinner } from '@hz-design-system/web-ui';

import { getHeroImageUrl, getExtraLargeImageUrl, getLargeHeroImageUrl } from '../../../../utils/getImageUrls';

import Classes from './Carousel.scss';

import { TListingGallery } from 'types/TListing';

type TCarouselImageProps = {
  index?: number;
  isModal?: boolean;
  alt: string;
  imageIndex: number;
  imageUrl: string;
  imageSizes?: TListingGallery['media']['imageSizes'];
  showLargePhotos: boolean;
  onEnterKeyPress?: (index: number) => void;
};

const getImageUrl = (imageUrl, isModal, showLargePhotos, imageSizes) => {
  if (isModal) {
    return getExtraLargeImageUrl(imageUrl, imageSizes);
  } else if (showLargePhotos) {
    return getLargeHeroImageUrl(imageUrl, imageSizes);
  } else {
    return getHeroImageUrl(imageUrl, imageSizes);
  }
};

const loadImage = (imageArrayIndex, currentImageIndex) =>
  [currentImageIndex, currentImageIndex + 1, currentImageIndex - 1].includes(imageArrayIndex);

const isSelected = (selectedIndex, currentIndex) => selectedIndex === currentIndex;

const CarouselImage = ({
  alt,
  index = 0,
  isModal = false,
  imageIndex,
  imageUrl,
  imageSizes,
  showLargePhotos,
  onEnterKeyPress,
}: TCarouselImageProps) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const tabIndexForImage = !isModal && imageIndex === 0 ? 0 : -1;
  const handleImageLoaded = () => {
    setIsLoaded(true);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && onEnterKeyPress) {
      onEnterKeyPress(index);
    }
  };

  return (
    <div className={`${Classes.container} ${isModal ? Classes.dialogContainer : ''}`}>
      {loadImage(imageIndex, index) && (
        <>
          {!isLoaded && <Spinner absolute />}
          <img
            className={`${Classes.image} ${isModal ? Classes.dialogImage : ''}`}
            src={getImageUrl(imageUrl, isModal, showLargePhotos, imageSizes)}
            fetchpriority={isSelected(index, imageIndex) ? 'high' : 'auto'}
            alt={alt}
            tabIndex={tabIndexForImage}
            onKeyDown={handleKeyDown}
            title={alt}
            onLoad={handleImageLoaded}
          />
        </>
      )}
    </div>
  );
};

export default CarouselImage;
